export const LANGUAGE_DISPLAY_BY_CODE: Record<string, string> = {
  '1025': 'Arabic (Saudi Arabia)',
  '1026': 'Bulgarian',
  '1027': 'Catalan',
  '1028': 'Chinese (Taiwan)',
  '1029': 'Czech',
  '1030': 'Danish',
  '1031': 'German',
  '1032': 'gr-GR',
  '1033': 'English (USA)',
  '1034': 'Spanish (Spain)',
  '1035': 'Finnish',
  '1036': 'French (France)',
  '1037': 'Hebrew',
  '1038': 'Hungarian',
  '1039': 'is-IL',
  '1040': 'Italian',
  '1041': 'Japanese',
  '1042': 'Korean',
  '1043': 'Dutch (Netherlands)',
  '1044': 'Norwegian Bokmål',
  '1045': 'Polish',
  '1046': 'Portuguese (Brazil)',
  '1047': 'Romansh (Switzerland)',
  '1048': 'Romanian',
  '1049': 'Russian',
  '1050': 'hr-HV',
  '1051': 'Slovak',
  '1052': 'sq-al',
  '1053': 'Swedish',
  '1054': 'Thai',
  '1055': 'Turkish',
  '1056': 'Urdu',
  '1057': 'Indonesian',
  '1058': 'Ukrainian',
  '1059': 'Belarusian (Belarus)',
  '1060': 'Slovenian',
  '1061': 'Estonian',
  '1062': 'Latvian',
  '1063': 'Lithuanian',
  '1065': 'Persian (Iran)',
  '1066': 'Viernamese (Vietnam)',
  '1067': 'Armenian (Armenia)',
  '1068': 'Azerbaijani (Azerbaijan)',
  '1069': 'Basque',
  '1070': 'Sorbian (Germany)',
  '1071': 'Macedonian',
  '1072': 'Sesotho (South Africa)',
  '1073': 'Tsonga (Mozambique)',
  '1074': 'Tswana (Belize)',
  '1076': 'Xhosa (South Africa)',
  '1077': 'Zulu (South Africa)',
  '1078': 'Afrikaans (South Africa)',
  '1079': 'Georgian (Georgia)',
  '1080': 'Faroese (Faroe Islands)',
  '1081': 'Hindi',
  '1082': 'Maltese (Malta)',
  '1084': 'Scottish Gaelic (United Kingdom)',
  '1085': 'Yiddish',
  '1086': 'Malay',
  '1087': 'Kazakh',
  '1088': 'Kirghiz (Kyrgyzstan)',
  '1089': 'Swahili (Kenya)',
  '1091': 'Uzbek (Uzbekistan)',
  '1092': 'Tatar (Turkey)',
  '1094': 'Punjabi',
  '1095': 'Gujarati',
  '1097': 'Tamil',
  '1098': 'Telugu',
  '1099': 'Kannada',
  '1102': 'Marathi',
  '1103': 'Sanskrit (India)',
  '1104': 'Mongolian (Mongolia)',
  '1110': 'Galician',
  '1111': 'Konkani (India)',
  '1114': 'Syriac (Syria)',
  '1125': 'Divehi (Maldives)',
  '2049': 'Arabic (Iraq)',
  '2052': 'Chinese (PRC)',
  '2055': 'German (Switzerland)',
  '2057': 'English (United Kingdom)',
  '2058': 'Spanish (Mexico)',
  '2060': 'French (Belgium)',
  '2064': 'Italian (Switzerland)',
  '2067': 'Dutch (Belgium)',
  '2068': 'Norwegian Nynorsk (Norway)',
  '2070': 'Portuguese (Portugal)',
  '2072': 'Romanian',
  '2073': 'Russian',
  '2074': 'Serbian (Serbia)',
  '2077': 'Swedish (Finland)',
  '2092': 'Azerbaijani (Azerbaijan)',
  '2110': 'Malay (Brunei Darussalam)',
  '2115': 'Uzbek (Uzbekistan)',
  '3073': 'Arabic (Egypt)',
  '3076': 'Chinese (Hong Kong)',
  '3079': 'German (Austria)',
  '3081': 'English (Australia)',
  '3082': 'Spanish',
  '3084': 'French (Canada)',
  '3098': 'Serbian (Latin)',
  '4097': 'Arabic (Libya)',
  '4100': 'Chinese (Singapore)',
  '4103': 'German (Luxembourg)',
  '4105': 'English (Canada)',
  '4106': 'Spanish (Guatemala)',
  '4108': 'French (Switzerland)',
  '5121': 'Arabic (Algeria)',
  '5124': 'Chinese (Traditional)',
  '5127': 'German (Liechtenstein)',
  '5129': 'English (New Zealand)',
  '5130': 'Spanish (Costa Rica)',
  '5132': 'French (Luxembourg)',
  '6145': 'Arabic (Morocco)',
  '6153': 'English (Ireland)',
  '6154': 'Spanish (Panama)',
  '6156': 'French (Monaco)',
  '7169': 'Arabic (Tunisia)',
  '7177': 'English',
  '7178': 'Spanish (Dominican Republic)',
  '8193': 'Arabic (Oman)',
  '8201': 'English (Jamaica)',
  '8202': 'Spanish (Venezuela)',
  '9217': 'Arabic (Yemen)',
  '9225': 'English',
  '9226': 'Spanish (Colombia)',
  '10241': 'Arabic (Syria)',
  '10249': 'English (Belize)',
  '10250': 'Spanish (Peru)',
  '11265': 'Arabic (Jordan)',
  '11273': 'English (Trinidad)',
  '11274': 'Spanish (Argentina)',
  '12289': 'Arabic (Lebanon)',
  '12297': 'English (Zimbabwe)',
  '12298': 'Spanish (Ecuador)',
  '13313': 'Arabic (Kuwait)',
  '13321': 'English (Philippines)',
  '13322': 'Spanish (Chile)',
  '14337': 'Arabic (U.A.E.)',
  '14346': 'Spanish (Uruguay)',
  '15361': 'Arabic (Bahrain)',
  '15370': 'Spanish (Paraguay)',
  '16385': 'Arabic (Qatar)',
  '16393': 'English (India)',
  '16394': 'Spanish (Bolivia)',
  '17418': 'Spanish (El Salvador)',
  '18442': 'Spanish (Honduras)',
  '19466': 'Spanish (Nicaragua)',
  '20490': 'Spanish (Puerto Rico)',
  '33801': 'English',
};
